<template>
	<div id="product">
		<header-menu curPage='product'></header-menu>
		<div class="product-section">
			<div class="title">产品优势</div>
			<div class="description">聚合了多家的优质广告联盟，免去媒体自己选择苦恼，评估的成本帮助您在变现业务上拓展更多成熟变现渠道</div>
			<div class="logo-table">
				<div class="logo-table-row">
					<img class="logo-item" src="https://cdn.huimiaokeji.com/hjweb/logo_kwai_alliance%402x.png"/>
					<img class="logo-item" src="https://cdn.huimiaokeji.com/hjweb/logo_youliang_hui%402x.png"/>
					<img class="logo-item" src="https://cdn.huimiaokeji.com/hjweb/logo_pangolin%402x.png"/>
					<img class="logo-item" src="https://cdn.huimiaokeji.com/hjweb/logo_baidu_alliance%402x.png"/>
					<img class="logo-item" src="https://cdn.huimiaokeji.com/hjweb/logo_360_alliance%402x.png"/>
				</div>
				<div class="logo-table-row">
					<img class="logo-item" src="https://cdn.huimiaokeji.com/hjweb/logo_sigmob%402x.png"/>
					<img class="logo-item" src="https://cdn.huimiaokeji.com/hjweb/logo_taptap%402x.png"/>
					<img class="logo-item" src="https://cdn.huimiaokeji.com/hjweb/logo_huawei%402x.png"/>
					<img class="logo-item" src="https://cdn.huimiaokeji.com/hjweb/logo_mintegral%402x.png"/>
					<img class="logo-item" src="https://cdn.huimiaokeji.com/hjweb/logo_qumeng%402x.png"/>
				</div>
				<div class="logo-table-row">
					<img class="logo-item" src="https://cdn.huimiaokeji.com/hjweb/logo_channel_identification%402x.png"/>
					<img class="logo-item" src="https://cdn.huimiaokeji.com/hjweb/logo_w%402x.png"/>
					<img class="logo-item" src="https://cdn.huimiaokeji.com/hjweb/logo_am%402x.png"/>
					<img class="logo-item" src="https://cdn.huimiaokeji.com/hjweb/logo_oppo%402x.png"/>
					<img class="logo-item" src="https://cdn.huimiaokeji.com/hjweb/logo_youkeying%402x.png"/>
				</div>
			</div>
		</div>
		<div class="product-section2">
			<!-- <div class="section2-title1">一站式APP广告变现平台</div> -->
			<div class="content">
				<!-- <el-row style="margin-top: 50px;">
					<el-col :span="11">
						<el-input v-model="form.name" placeholder="输入姓名"></el-input>
					</el-col>
					<el-col :span="2">
						&nbsp;
					</el-col>
					<el-col :span="11">
						<el-input v-model="form.phone" placeholder="输入手机号"></el-input>
					</el-col>
				</el-row>
				<el-input v-model="form.projectName" placeholder="输入项目名称" style="margin-top: 20px;"></el-input>
				<el-input v-model="form.companyName" placeholder="输入公司名称" style="margin-top: 20px;"></el-input>
				<div class="section2-btn">立即咨询</div>
				<div class="section2-line"></div> -->
				<div class="section2-title2">扫码联系我们</div>
				<div class="card-box">
					<div class="card-panel">
						<div class="card-panel-qrcode">
							<img class="qrcode-icon" src="https://cdn.huimiaokeji.com/hjweb/qrcode.png"/>
						</div>
						<div class="card-panel-right">
							<div class="right-title">商务联系方式</div>
							<div class="right-rows">
								<el-row>
									<el-col :span="6">联系方式</el-col>
									<el-col :span="12">17826840773(微信同号)</el-col>
								</el-row>
								<el-row style="margin-top: 20px;">
									<el-col :span="6">电子邮箱</el-col>
									<el-col :span="12">hjwl0575@163.com</el-col>
								</el-row>
								<el-row style="margin-top: 20px;">
									<el-col :span="6">Telegram</el-col>
									<el-col :span="12">https://t.me/huijing02</el-col>
								</el-row>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<footer-menu></footer-menu>
	</div>
</template>

<script>
	import HeaderMenu from '../components/header-menu.vue';
	import FooterMenu from '../components/footer-menu.vue';
	export default {
		name:'product',
		components: {
			HeaderMenu,
			FooterMenu
		},
		data() {
			return {
				form: {
					name: null,
					phone: null,
					projectName: null,
					companyName: null
				}
			}
		},
		created() {
		  document.title = '灰鲸网络-产品优势';
		},
		methods: {
			
		}
	}
</script>

<style lang="less">
	#product {
		background-color: #FFFFFF;
		.product-section {
			width: 100%;
			height: 820px;
			background: #F3F7FF;
			.title {
				padding-top: 100px;
				padding-left: 10%;
				font-family: PingFangSC, PingFang SC;
				font-weight: bold;
				font-size: 34px;
				color: #0B00B5;
				line-height: 34px;
				text-align: left;
				font-style: normal;
			}
			.description {
				margin-top: 40px;
				padding-left: 10%;
				font-family: PingFangSC, PingFang SC;
				font-weight: 400;
				font-size: 22px;
				color: #333333;
				line-height: 22px;
				text-align: left;
				font-style: normal;
			}
			.logo-table {
				width: 100%;
				margin-top: 100px;
				.logo-table-row {
					padding-left: 10%;
					padding-right: 10%;
					display: flex;
					justify-content: space-between;
					margin-bottom: 40px;
					.logo-item {
						width: 208px;
						height: 106px;
					}
				}
			}
		}
		.product-section2 {
			height: 530px;
			.section2-title1 {
				padding-top: 100px;
				font-family: PingFangSC, PingFang SC;
				font-weight: bold;
				font-size: 26px;
				color: #0B00B5;
				line-height: 26px;
				text-align: center;
				font-style: normal;
			}
			.content {
				width: 80%;
				margin-left: 10%;
			}
			.el-input__inner {
				background-color: #F3F7FF;
				height: 66px;
				line-height: 66px;
			}
			.section2-btn {
				height: 76px;
				background: #0B00B5;
				margin-top: 40px;
				font-family: PingFangSC, PingFang SC;
				font-weight: bold;
				font-size: 16px;
				color: #FFFFFF;
				line-height: 76px;
				text-align: center;
				font-style: normal;
				cursor: pointer;
			}
			.section2-line {
				margin-top: 100px;
				width: 100%;
				height: 1px;
				background: #E6E5F7;
			}
			.section2-title2 {
				margin-top: 100px;
				font-family: PingFangSC, PingFang SC;
				font-weight: bold;
				font-size: 26px;
				color: #0B00B5;
				line-height: 26px;
				text-align: center;
				font-style: normal;
			}
			.card-box {
				margin-top: 50px;
				height: 314px;
				background: #F3F7FF;
				padding-left: 10%;
				padding-right: 10%;
				.card-panel {
					display: flex;
					.card-panel-qrcode {
						height: 314px;
						flex:2;
						display: flex;
						align-items: center;
						justify-content: center;
						.qrcode-icon {
							width: 194px;
							height: 194px;
						}
					}
					.card-panel-right {
						flex:3;
						.right-title {
							padding-top: 80px;
							font-family: PingFangSC, PingFang SC;
							font-weight: bold;
							font-size: 24px;
							color: #333333;
							line-height: 24px;
							text-align: left;
							font-style: normal;
						}
						.right-rows{
							margin-top: 30px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 400;
							font-size: 20px;
							color: #333333;
							line-height: 20px;
							text-align: left;
							font-style: normal;
						}
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/Product.vue